import DialogFunctions from "../../../core/dialogFunctions";

class AddDistrictDialogController extends DialogFunctions {
  constructor($mdDialog) {
    "ngInject";

    super($mdDialog);
  }
}

export default AddDistrictDialogController;



// WEBPACK FOOTER //
// ./src/pages/districts/addDistrictDialog/addDistrictDialog.controller.js